export default __webpack_public_path__ + "static/media/ArrowDownActive.fb25531b.svg";